/* 
Mixin for exposing lookup details and making sure that they are loaded and sufficiently up-to-date.
*/
import _ from "underscore";
import * as action from "@/store/lookups/action-types";
import moment from "moment";

export default {
  mounted() {
    const fiveMinutesAgo = moment().subtract(5, "minutes");
    if (
      !this.lookupsState.loading &&
      (!this.lookupsState.loaded || moment(this.lookupsState.lastRefreshed) < fiveMinutesAgo)
    ) {
      this.$store.dispatch(action.LOAD_STATIC_LOOKUPS);
      this.$store.dispatch(action.LOAD_DYNAMIC_LOOKUPS);
    }
  },
  computed: {
    lookupsState() {
      return this.$store.state.lookups;
    },
    lookups() {
      return this.lookupsState.data;
    },
    lookupsLoaded() {
      return this.lookupsState.loaded;
    }
  },
  methods: {
    getLookup(value, lookupDetails) {
      return lookupDetails.find(k => k.value == value);
    },
    doesLookupHaveAttribute(value, attribute, lookupDetails) {
      const item = this.getLookup(value, lookupDetails);
      if (item) {
        return item.attributes.includes(attribute);
      }
      return false;
    },
    getLookupsWithoutAttribute(lookups, attribute) {
      return _(lookups).filter(k => !k.attributes.includes(attribute));
    },
    getLookupsWithAttribute(lookups, attribute) {
      return _(lookups).filter(k => k.attributes.includes(attribute));
    },
    getLookupValuesWithoutAttribute(lookups, attribute) {
      return _(this.getLookupsWithoutAttribute(lookups, attribute)).pluck("value");
    },
    getLookupValuesWithAttribute(lookups, attribute) {
      return _(this.getLookupsWithAttribute(lookups, attribute)).pluck("value");
    }
  }
};
